import { AwardsAttachments } from '../../types/AwardsAttachments'
import { awardsApi } from '../index'

export const fetchDetails = (slug: string) => awardsApi.get<AwardsAttachments>(`files/entries/${slug}`)
